import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      createElementVNode("path", { d: "M2.25.75h19.5s1.5 0 1.5 1.5v19.5s0 1.5-1.5 1.5H2.25s-1.5 0-1.5-1.5V2.25s0-1.5 1.5-1.5M12 15.72v7.53" }),
      createElementVNode("path", { d: "M13.69 13.82a.73.73 0 0 1 .35-.47.74.74 0 0 1 .58-.07 2.22 2.22 0 0 0 2.49-.51c.36-.61 0-1.64-.8-2.41a.78.78 0 0 1-.23-.54.76.76 0 0 1 .23-.54c.8-.77 1.16-1.81.8-2.42a2.22 2.22 0 0 0-2.49-.51.74.74 0 0 1-.62-.07.73.73 0 0 1-.35-.47c-.27-1.08-1-1.9-1.69-1.9s-1.42.82-1.69 1.9a.73.73 0 0 1-.35.47.74.74 0 0 1-.58.07 2.22 2.22 0 0 0-2.49.51c-.36.61 0 1.65.8 2.42a.76.76 0 0 1 .23.54.78.78 0 0 1-.23.54c-.8.77-1.16 1.8-.8 2.41a2.22 2.22 0 0 0 2.49.51.74.74 0 0 1 .58.07.73.73 0 0 1 .35.47c.27 1.08 1 1.9 1.69 1.9s1.46-.82 1.73-1.9" }),
      createElementVNode("path", { d: "M10.5 9.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M8.71 20.62A4.45 4.45 0 0 1 7 19.94c-1.76-1.08-3.17-4-3.17-4a9.2 9.2 0 0 1 5.19 1.2m6.33 3.48a4.3 4.3 0 0 0 1.65-.68c1.77-1.08 3.18-4 3.18-4a9.27 9.27 0 0 0-5.2 1.2" })
    ], -1)
  ]));
}
const imagePictureFlower = { render };
export {
  imagePictureFlower as default,
  render
};
//# sourceMappingURL=image-picture-flower.svg.js.map
